import React, { useEffect } from "react";
import classNames from "classnames";
import refreshPrintQueue from "../refreshPrintQueue/refreshPrintQueue.js"
import config from "../../config/config.json";

const printerStatusUrl = `https://${config.ip}:631/jobs/`


const Modal = ({ isOpen, onClose, children, settings, toggleSettings }) => {
  let modalClasses = classNames({
    hidden: !isOpen,
    fixed: true,
    "inset-0": true,
    "top-0": true,
    "left-0": true,
    "z-50": true,
    flex: true,
    "items-center": true,
    "justify-center": true,
    "w-full": true,
    "h-screen": true,
    "min-h-screen": true,
    "bg-black": true,
    "bg-opacity-50": true,
    "backdrop-blur-sm": true,
  });


  return (
    <div id="modal--settings" className={modalClasses}>
      <div className="modal-box">
        <button
          onClick={onClose}
          className="px-4 py-2 mb-4 text-white bg-red-500 rounded hover:bg-red-600 focus:outline-none"
        >
          Close
        </button>
        <div className="modal-action">
          <form action="dialog">
            <label>
              Password:
              <input type="text" />
            </label>
            <button type="submit">Submit</button>
          </form>
        </div>
        <div className="modal--content">
          <form action="dialog">
            <label>
              Enable single image column option
              <input
                type="checkbox"
                checked={settings}
                onChange={toggleSettings}
              />
            </label>
          </form>

          <a className="btn btn-secondary" href={printerStatusUrl} target="_blank">Open printer admin</a>
          {/* <button className="btn btn-secondary" onClick={refreshPrintQueue}>Refresh print queue</button> */}
        </div>
      </div>
    </div>
  );
};

export default Modal;
